/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs */

const en_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete daily Focus Challenges to collect Time Crystals, or visit the Time Crystal Store to top up!`)
};

const ar_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل مهام تحديات التركيز اليومية لجمع بلورات الزمن، أو قم بزيارة متجر بلورة الزمن للتعبئة!`)
};

const de_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe tägliche Fokus Herausforderungens ab, um Zeitkristalle zu sammeln, oder besuche den Time Crystal Store, um aufzuladen!`)
};

const es_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa los Desafíos de concentración diarios para conseguir Cristales de Tiempo o visita la Tienda de cristales de tiempo para recargarlos.`)
};

const fr_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complétez les Défi de Concentration quotidiens pour collecter des Cristaux de Temps, ou rendez-vous à La boutique de gemme pour faire le plein !`)
};

const it_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le Sfide di concentrazione giornaliere per raccogliere Cristalli del Tempo, o visita il Negozio dei Cristalli del Tempo per ricaricarli!`)
};

const ja_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日集中チャレンジをクリアして時の結晶を集めるか、時の結晶ストアで補充しましょう！`)
};

const ko_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 집중 챌린지를 완료하고 타임 크리스탈을 수집하거나 타임 크리스탈 상점에서 충전하세요!`)
};

const pt_br_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua Desafio de Foco diariamente para coletar Cristais do Tempo ou visite a Loja de Loja de cristais do tempo para reabastecer!`)
};

const ru_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполните ежедневное Задание по фокусировке, чтобы собрать Кристаллы времени, или посетите Кристальный магазин времени для пополнения!`)
};

const th_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความท้าทายการโฟกัสประจำวันให้สำเร็จเพื่อสะสมคริสตัลแห่งกาลเวลา หรือไปที่ร้านคริสตัลแห่งกาลเวลาเพื่อเติมมันได้!`)
};

const tr_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Odaklanma Mücadeleleri tamamlayarak Zaman Kristalleri topla veya daha fazlası için Zaman Kristali Mağazasını ziyaret et!`)
};

const zh_cn_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日专注挑战累计时光宝石，或前往时光宝石商店补充！`)
};

const zh_tw_dialog_not_enough_balance_gem_store_description = /** @type {(inputs: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日專注挑戰累積時光寶石，或前往時光寶石商店商店補充！`)
};

/**
* | output |
* | --- |
* | "Complete daily Focus Challenges to collect Time Crystals, or visit the Time Crystal Store to top up!" |
*
* @param {Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_balance_gem_store_description = /** @type {((inputs?: Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Balance_Gem_Store_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "de") return de_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "es") return es_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "it") return it_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "th") return th_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_balance_gem_store_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_balance_gem_store_description(inputs)
	return zh_tw_dialog_not_enough_balance_gem_store_description(inputs)
});